<template>
  <div class="basicBox">
    <div class="img1">
      <img src="../../static/home/company2.jpg" alt="">
    </div>
    <div class="commondiv">山西复盛公健康药业有限公司成立于2019年9月11日，注册资本5000万元，占地52亩，位于"晋商故里"祁县经济开发区朝阳西街4号，毗邻多家世界级品牌企业，同属晋商文化旅游、经济、工业圈中心，与国家历史文化名城"乔家大院"相距仅3公里，是祁县重点招商引资项目。</div>
    <div class="commondiv">公司是一家现代化医药批发企业，拥有完善的管理体系和现代化的物流管理系统，公司主营批发：中成药、化学药制剂、抗生素、生化药品、生物制品（除疫苗）；保健食品；生物科学技术的开发与技术转让等，核心业务从品牌管理拓展到医药批发、医药零售、中医馆加盟、终端直供、大健康产业以及电子商务等领域。截止2021年底，公司建成2万多平米的现代化医药物流仓库，于2021年2月通过省药监局验收并正式投入使用。</div>
    <div class="commondiv">公司始终坚持"工商联盟、统一品牌、服务终端、共赢未来"的发展理念，以地市县为销售单元，传播健康理念，满足消费者价值。公司董事长宋守业先生始终铭记公司应担负的社会责任与义务。2020年1月30日，公司为支持武汉疫情慷慨捐赠价值100万元的医药物资，山西省红十字会代表政府接受了这批物资。2021年7月，公司爱心援助20万赈灾物资驰援河南；2021年10月，省内出现持续大面积强降雨，多地都创下了10月上旬累计降雨量历史记录。在此危难之际，公司与祁县统战部与工商联取得联系，捐赠价值25万元赈灾急需药品。2022年10月8日祁县疫情，董事长宋守业先生亲自带队第一时间捐赠价值10万元的医疗物资，实际行动为家乡疫情防控贡献力量。</div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  components: {
  },
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>
<style scoped lang="less">
.basicBox{
  margin: 0;
  width: 70%;
  padding: 80px 15% 100px;
  font-size: 16px;
  line-height: 28px;
  img{
    width: 100%;
    height: 100%;
  }
  .img1{
    width: 100%;
    height: 600px;
    margin-bottom: 50px;
  }
  .commondiv{
    text-indent: 2em;
    margin: 10px 0;
  }
  .putong{
    margin: 30px 0; 
    font-size: 20px;
    line-height: 40px;
    font-weight: 700;
  }
  .bottom{
    font-size: 22px;
    margin-top: 40px;
  }
}
</style>